module.exports = __webpack_public_path__ + "img/audio.d8c2f2d6.png";